require('./retailLoanOfferType.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

const RetailLoanOfferType = (props) => {

    const { item, highlightText } = props;

    return (
        <React.Fragment>
            <div className="retail-loan-offer-type">
                <span className="retail-loan-offer-type__text">
                    {highlightText ? highlightText : item.get('field_commercial_text_web')}
                </span>
            </div>
        </React.Fragment>
    );
}

RetailLoanOfferType.propTypes = {
    item: PropTypes.object,
    highlightText: PropTypes.string,
};

export { RetailLoanOfferType };
